import React from 'react';
import { MenuListProps, components } from 'react-select';

export function MenuListWithPreventCloseOnScroll<T>() {
  return ({ className, ...props }: MenuListProps<T>) => (
    <components.MenuList {...props} />
  );
}
